export enum EngineTypes {
    DICTATION = "DICTATION",
    CLASSIC = "CLASSIC"
}
